<template>
  <div class="employeedashboard" id="employee">
    <div class="main-wrapper">
      <!-- <layout-loader></layout-loader> -->
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-12">
              <div class="welcome-box">
                <div class="welcome-img">
                  <img
                    alt=""
                    src="~@/assets/profiles/avatar-02.jpg"
                    v-if="!currentUser.employee.passportPhoto"
                  />
                  <img
                    alt=""
                    :src="media + currentUser.employee.passportPhoto"
                    width="38"
                    v-if="currentUser.employee.passportPhoto"
                  />
                </div>
                <div class="welcome-det">
                  <h3>Welcome, {{ currentUser.user.fullName }}</h3>
                </div>
              </div>
            </div>
            <div class="alert alert-success" role="alert" v-if="period.departmentId === null || period.departmentId === currentUser.employee.designation.departmentId">
              <h4 class="alert-heading">Performance Time!</h4>
              <p>It’s time for you to complete your self-assessment. This is an opportunity for you to reflect on your achievements, challenges, and overall contributions over the review period.</p>
              <hr>
              <p class="mb-0">Kindly complete your self-review by {{ period.endDate ? new Date(period.endDate).toLocaleDateString() : '' }}.  <a @click="startReview" style="color: #E24F55;">Start Now</a></p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-8 col-md-8">
              <section class="dash-section">
                <div
                  class="dash-sec-content"
                  style="margin-bottom: 10px"
                  v-if="activeInterviewer"
                >
                  <div class="dash-info-list">
                    <div
                      class="dash-card"
                      style="background-color: #55ce63 !important; color: #fff !important;"
                    >
                      <div class="dash-card-container">
                        <div class="dash-card-icon">
                          <i class="fa fa-hourglass-o"></i>
                        </div>
                        <div class="dash-card-content">
                          <p>
                            We are waiting for your feedback based on interview
                            we invited you
                          </p>
                        </div>
                        <div class="dash-card-avatars">
                          <router-link
                            class="btn"
                            style="background-color: #fff !important; color: #000 !important;"
                            :to="`/feedback`"
                            >Add FeedBack</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="dash-sec-content"
                  style="margin-bottom: 10px"
                  v-if="goals.length > 0"
                >
                  <div class="dash-info-list">
                    <div
                      class="dash-card"
                      style="background-color: #5B5FC7 !important; color: #fff !important;"
                    >
                      <div class="dash-card-container">
                        <div class="dash-card-icon">
                          <i class="fa fa-hourglass-o"></i>
                        </div>
                        <div class="dash-card-content">
                          <p>
                            {{
                              goals.length > 1
                                ? `${goals[0].employee.firstName} ${goals[0].employee.lastName} and others`
                                : goals.length == 1
                                ? `${goals[0].employee.firstName} ${goals[0].employee.lastName}`
                                : `Colleagues`
                            }}
                            waiting for your rating
                          </p>
                        </div>
                        <div class="dash-card-avatars">
                          <router-link
                            class="btn"
                            style="background-color: #fff !important; color: #000 !important;"
                            :to="`/partner-performance-goals`"
                            >Rate Now</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h1 class="dash-sec-title">Today</h1>
                <div class="dash-sec-content" style="margin-bottom: 10px">
                  <div
                    class="dash-info-list"
                    v-for="item in todayAbsence"
                    :key="item.id"
                  >
                    <a
                      href="#"
                      class="dash-card"
                      style="background-color: #E24F55 !important; color: #fff !important;"
                    >
                      <div class="dash-card-container">
                        <div class="dash-card-icon">
                          <i class="fa fa-hourglass-o"></i>
                        </div>
                        <div class="dash-card-content">
                          <p>
                            {{
                              item.employee.firstName +
                                " " +
                                item.employee.lastName
                            }}
                            is off today due to {{ item.leaveType.name }} leave
                          </p>
                        </div>
                        <div class="dash-card-avatars">
                          <div class="e-avatar">
                            <img
                              alt=""
                              src="~@/assets/profiles/avatar-02.jpg"
                              v-if="!currentUser.employee.passportPhoto"
                            />
                            <img
                              alt=""
                              :src="media + currentUser.employee.passportPhoto"
                              width="38"
                              v-if="currentUser.employee.passportPhoto"
                            />
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    class="dash-info-list"
                    v-for="item in todayBirthdays"
                    :key="item.id"
                  >
                    <a
                      href="#"
                      class="dash-card"
                      style="background-color: #1573BE !important; color: #fff !important;"
                    >
                      <div class="dash-card-container">
                        <div class="dash-card-icon">
                          <i class="fa fa-calendar-check-o"></i>
                        </div>
                        <div class="dash-card-content">
                          <p>
                            {{ item.firstName + " " + item.lastName }}'s
                            birthday is today
                          </p>
                        </div>
                        <div class="dash-card-avatars">
                          <div class="e-avatar">
                            <img
                              alt=""
                              src="~@/assets/profiles/avatar-02.jpg"
                              v-if="!item.passportPhoto"
                            />
                            <img
                              alt=""
                              :src="media + item.passportPhoto"
                              width="38"
                              v-if="item.passportPhoto"
                            />
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                <h1 class="dash-sec-title">Upcoming Holidays</h1>
                <div class="dash-sec-content">
                  <div
                    class="dash-info-list"
                    v-for="item in holidays"
                    :key="item.id"
                  >
                    <a
                      href="#"
                      class="dash-card"
                      style="background-color: #785696 !important; color: #fff !important;"
                    >
                      <div class="dash-card-container">
                        <div class="dash-card-icon">
                          <i class="fa fa-bullhorn"></i>
                        </div>
                        <div class="dash-card-content">
                          <!-- <p>
                            {{ item.title }} holiday is {{ item.day }}
                            {{ new Date(item.holiday).getDate() }},
                            {{ new Date(item.holiday).getMonth() }}

                          </p> -->
                          <p>
                            {{
                              `${item.title} hoilday is  ${
                                item.day
                              },   ${getHoliday(item.holiday)} ${new Date(
                                item.holiday
                              ).getDate()}
                              `
                            }}
                          </p>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </section>
            </div>
            <div class="col-lg-4 col-md-4">
              <div class="dash-sidebar">
                <section v-for="item in leaveEgb" :key="item.id">
                  <div v-if="item.leaveTypeName === 'Annual'">
                    <h5 class="dash-title">
                      Your {{ item.leaveTypeName }} Leave
                    </h5>
                    <div
                      class="card"
                      style="background-color: #111744 !important; color: #fff !important;"
                    >
                      <div class="card-body">
                        <div class="time-list">
                          <div class="dash-stats-list">
                            <h4 style=" color: #fff !important;">
                              {{ item.used }}
                            </h4>
                            <p style=" color: #fff !important;">Leave Taken</p>
                          </div>
                          <div class="dash-stats-list">
                            <h4 style=" color: #fff !important;">
                              {{ item.eligible - item.used }}
                            </h4>
                            <p style=" color: #fff !important;">Remaining</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div v-else-if="currentUser.employee.gender == 'female'">
                    <h5 class="dash-title">
                      Your {{ item.leaveTypeName }} Leave
                    </h5>
                    <div
                      class="card"
                      style="background-color: #111744 !important; color: #fff !important;"
                    >
                      <div class="card-body">
                        <div class="time-list">
                          <div class="dash-stats-list">
                            <h4 style=" color: #fff !important;">
                              {{ item.used }}
                            </h4>
                            <p style=" color: #fff !important;">Leave Taken</p>
                          </div>
                          <div class="dash-stats-list">
                            <h4 style=" color: #fff !important;">
                              {{ item.eligible - item.used }}
                            </h4>
                            <p style=" color: #fff !important;">Remaining</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </section>
              </div>
            </div>
            <div class="col-lg-7 col-sm-6" v-if="disciplines.length > 0">
              <div class="accordion" id="disciplineCard">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingOne">
                    <button
                      class="accordion-button dash-title text-uppercase"
                      style="font-size: 18px; font-weight: 700;"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      You have
                      <span class="text-danger">{{ disciplines.length }}</span>
                      {{
                        disciplines.length > 1
                          ? " New Disciplinary Cases"
                          : " New Disciplinary Case"
                      }}
                    </button>
                  </h2>
                  <div
                    class="accordion-collapse collapse show"
                    id="collapseOne"
                    data-bs-parent="#disciplineCard"
                  >
                    <div class="accordion-body">
                      <div class="card">
                        <div class="card-body">
                          <v-data-table :headers="headers" :items="disciplines">
                            <template
                              v-slot:item.suspensionStartDate="{ item }"
                            >
                              {{
                                item.suspensionStartDate
                                  ? new Date(
                                      item.suspensionStartDate
                                    ).toDateString()
                                  : "-"
                              }}
                            </template>
                            <template v-slot:item.view="{ item }">
                              <a
                                @click="openView(item)"
                                class=""
                                ><i class="fa fa-eye"></i> View</a
                              ></template
                            >
                          </v-data-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->

        <!-- Modals -->
        <v-dialog v-model="dialogView" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Disciplinary Measure</h5>
              <button type="button" class="close" @click="closeView">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div>
                <div class="form-group">
                  <label>Date</label>
                  <div class="cal-icon">
                    <datepicker
                      v-model="discipline.date"
                      calendar-class
                      input-class
                      disabled
                      bootstrap-styling
                      class="form-control datetimepicker"
                      type="text"
                    />
                  </div>
                </div>

                <!-- <div class="form-group">
                      <label>Form <span class="text-danger">*</span></label>
                      <input class="form-control" v-model="disciplinary.form" />
                  </div> -->
                <div class="form-group">
                  <label>Form</label>
                  <select
                    class="select form-control"
                    v-model="discipline.form"
                    disabled
                  >
                    <option>-- Select --</option>
                    <option :value="1">Query</option>
                    <option :value="2">Warning</option>
                    <option :value="3">Suspension</option>
                    <option :value="4">Surcharge</option>
                  </select>
                </div>
                <div class="form-group" v-if="discipline.form === 3">
                  <label>Suspension Start Date</label>
                  <div class="cal-icon">
                    <datepicker
                      v-model="discipline.suspensionStartDate"
                      calendar-class
                      input-class
                      disabled
                      bootstrap-styling
                      class="form-control datetimepicker"
                      type="text"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label>Reason</label>
                  <textarea
                    class="form-control"
                    v-model="discipline.reason"
                    rows="4"
                    disabled
                  ></textarea>
                </div>
                <div class="form-group">
                  <label>Remark</label>
                  <textarea
                    class="form-control"
                    v-model="discipline.remark"
                    rows="4"
                    disabled
                  ></textarea>
                </div>
                <div class="submit-section">
                  <button @click="closeView" class="btn btn-primary submit-btn">Close</button>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Modals -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { authenticationService } from "@/services/authenticationService";
import { employeeService } from "@/services/employeeService.js";
import { performanceService } from "@/services/performanceService";
import { jobService } from "@/services/jobService.js";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
    return {
      currentUser: authenticationService.currentUserValue,
      company: authenticationService.currentOfficeValue,
      media: "data:image/jpeg;base64,",
      todayAbsence: [],
      todayBirthdays: [],
      holidays: [],
      leaveEgb: [],
      goals: [],
      activeInterviewer: false,
      message: false,
      week: "",
      period: null,
      disciplines: [],
      discipline: {},
      headers: [
        { text: "Remark", value: "remark", sortable: false },
        { text: "Start Date", value: "suspensionStartDate", sortable: false },
        { text: "", value: "view", sortable: false }
      ],
      dialogView: false,
      date: new Date().toISOString().slice(0, 10)
    };
  },

  methods: {
    getHoliday(date) {
      console.log(date);
      var currentDate = new Date(date).getDate();
      var currentMonth = new Date(date).getMonth();
      var currentYear = new Date().getFullYear();

      // let curr = new Date();
      // let week = [];

      // for (let i = 0; i <= 6; i++) {
      //   let first = curr.getDate() - curr.getDay() + i;
      //   let day = new Date(curr.setDate(first)).toISOString().slice(0, 10);
      //   week.push(day);
      // }
      // let x;

      // week.map(d => {
      //   if (date !== d) {
      //     console.log("this week");
      //     x = 2;
      //   }

      //   // }

      //   console.log(this.week);
      // });

      // switch (x) {
      //   case 1:
      //     return (this.week = "this week");
      //   case 2:
      //     return (this.week = "next week");
      // }

      // console.log(x);

      // console.log(week);

      // const today = moment();
      // const from_date = today.startOf("week");
      // const to_date = today.endOf("week");
      // console.log({
      //   from_date: from_date.toString(),
      //   today: moment().toString(),
      //   to_date: to_date.toString()
      // });

      // var startOfWeek = moment().startOf("isoWeek");
      // var endOfWeek = moment().endOf("isoWeek");

      // var days = [];
      // var day = startOfWeek;

      // while (day <= endOfWeek) {
      //   days.push(day.toDate());
      //   day = day.clone().add(1, "d");
      // }

      // console.log(days);

      // days.forEach(dates => {
      //   if (dates == date) {
      //     console.log("date found");
      //   }
      //   console.log(dates);
      // });

      let holiday = new Date(currentYear, currentMonth, currentDate);
      console.log(currentMonth);
      var dayNum = holiday.getMonth();
      console.log(currentDate);
      switch (dayNum) {
        case 0:
          return "January";
        case 1:
          return "Feburary";
        case 2:
          return "March";
        case 3:
          return "April";
        case 4:
          return "May";
        case 5:
          return "June";
        case 6:
          return "July";
        case 7:
          return "August";
        case 8:
          return "September";
        case 9:
          return "October";
        case 10:
          return "November";
        case 11:
          return "December";
      }
    },

    getTodayAbsence() {
      employeeService.getTodayAbsence(this.company.id).then(o => {
        this.todayAbsence = o;
      });
    },
    getThirdRater() {
      employeeService
        .getThirdRaterGoals(this.currentUser.employee.id)
        .then(o => {
          this.goals = o;
        });
    },
    getTodayBirthday() {
      employeeService.getTodayBirthdays(this.company.id).then(o => {
        this.todayBirthdays = o;
      });
    },
    getHolidayofWeek() {
      employeeService.getUpcomingHolidays().then(o => {
        this.holidays = o;
      });
    },
    getActiveReview () {
      performanceService.getActiveReviewPeriodByEmployee(this.currentUser.employee.id)
          .then(
            model => { 
              this.period = model
              console.log(model) 
            },
            error => { error = error }
          )
    },
    getEmployeeLeaveSummary() {
      employeeService
        .getEmployeeLeaveSummary(this.currentUser.employee.id)
        .then(
          model => {
            this.leaveEgb = model;

            console.log("leaves:", model, this.currentUser.employee.gender);
          },
          error => {
            error = error;
          }
        );
    },
    getRecentDiscipline() {
      employeeService.getRecentDiscipline(this.currentUser.employee.id).then(
        model => {
          this.disciplines = model;

          console.log("disciplines:", model, this.currentUser.employee.gender);
        },
        error => {
          error = error;
        }
      );
    },
    getAllApplications() {
      jobService
        .getApplicationInterviewersByEmployee(this.currentUser.employee.id)
        .then(p => {
          var activeInterview = p.filter(c => c.status == 0);
          this.activeInterviewer = activeInterview.length > 0;
        });
    },
    startReview() {
        var review = {
          employeeId: this.currentUser.employee.id,
          designationId: this.currentUser.employee.designationId,
          reviewPeriodId: this.period.id
        }

         performanceService.addReview(review).then(
            m => {
                this.$router.push('/employee-review-detail/'+m)
            },
            error => {
                this.error = error
            }
        )
    },
    openView(item) {
      this.discipline = item;
      this.dialogView = true;
    },
    closeView() {
      this.dialogView = false;
    }
  },
  mounted() {
    this.getActiveReview();
    this.getTodayAbsence();
    this.getHolidayofWeek();
    this.getTodayBirthday();
    this.getThirdRater();
    this.getEmployeeLeaveSummary();
    this.getAllApplications();
    this.getRecentDiscipline();

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  // getThis() {
  //   let curr = new Date();
  //   let week = [];

  //   for (let i = 0; i <= 6; i++) {
  //     let first = curr.getDate() - curr.getDay() + i;
  //     let day = new Date(curr.setDate(first)).toISOString().slice(0, 10);
  //     week.push(day);
  //   }

  //   week.forEach(d => {
  //     if (d === this.date) {
  //       this.week = "";
  //       console.log(this.date, d);
  //       // console.log(date);
  //       // console.log(d);
  //     } else if (d !== this.date) {
  //       this.week = "next week";
  //       console.log(this.date);
  //       console.log(curr);
  //     }
  //   });

  //   console.log(week);
  // },
  name: "employeedashboard"
};
</script>



// WEBPACK FOOTER //
// src/components/employeedashboard.vue